
import React from "react";
import { InfoIcon, AlertCircle } from "lucide-react";

interface ProgramOverviewProps {
  overview: string | null;
  isLoading?: boolean;
}

// Simple component with memoization since overview rarely changes
const ProgramOverviewComponent = ({ overview, isLoading = false }: ProgramOverviewProps) => {
  if (isLoading) {
    return (
      <div className="bg-white/5 rounded-md p-4 text-white/90">
        <div className="flex items-center gap-2 mb-2">
          <InfoIcon className="h-4 w-4 text-white/70" />
          <h4 className="font-medium">Overview</h4>
        </div>
        <div className="flex items-center space-x-2 text-white/70 italic">
          <div className="h-4 w-4 animate-spin rounded-full border-b-2 border-white/70"></div>
          <p>Loading program overview...</p>
        </div>
      </div>
    );
  }

  if (!overview) {
    return (
      <div className="bg-white/5 rounded-md p-4 text-white/90">
        <div className="flex items-center gap-2 mb-2">
          <InfoIcon className="h-4 w-4 text-white/70" />
          <h4 className="font-medium">Overview</h4>
        </div>
        <div className="flex items-center gap-2 text-amber-300 mb-2">
          <AlertCircle className="h-4 w-4" />
          <p className="text-sm font-medium">No overview available</p>
        </div>
        <p className="text-white/70 italic">No overview available for this program. This may be because the program data is still being generated or there was an issue retrieving it.</p>
      </div>
    );
  }
  
  return (
    <div className="bg-white/5 rounded-md p-4 text-white/90">
      <div className="flex items-center gap-2 mb-2">
        <InfoIcon className="h-4 w-4 text-white/70" />
        <h4 className="font-medium">Overview</h4>
      </div>
      <p className="whitespace-pre-wrap">{overview}</p>
    </div>
  );
};

export const ProgramOverview = React.memo(ProgramOverviewComponent);
